import { useCallback, useRef, useState } from 'react';
import { apiClient } from '../api/client';
import { consultaDoHistorico, type SignatureEntry, type SignatureHistory } from '../utils/signatureHistory';

/** Etapa 24: histórico de assinaturas, em páginas ("Carregar mais"). */
export function useSignatures() {
  const [items, setItems] = useState<SignatureEntry[]>([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // Só a resposta do pedido mais recente vale (a busca muda enquanto a anterior ainda carrega).
  const ultimoPedido = useRef(0);

  const fetchSignatures = useCallback(async (busca: string, maisUmaPagina = false, jaCarregados = 0) => {
    const pedido = ++ultimoPedido.current;
    setIsLoading(true);
    setError(null);
    try {
      const resposta = await apiClient.get<SignatureHistory>(
        `/certificates/signatures${consultaDoHistorico(busca, maisUmaPagina ? jaCarregados : 0)}`,
      );
      if (pedido !== ultimoPedido.current) return;
      setItems((atuais) => (maisUmaPagina ? [...atuais, ...resposta.items] : resposta.items));
      setTotal(resposta.total);
    } catch (err) {
      if (pedido !== ultimoPedido.current) return;
      setError(err instanceof Error && err.message ? err.message : 'Erro ao carregar o histórico de assinaturas.');
    } finally {
      if (pedido === ultimoPedido.current) setIsLoading(false);
    }
  }, []);

  return { items, total, isLoading, error, fetchSignatures };
}
